<template>
    <svg viewBox="0 0 2 2" class="mx-2 inline size-0.5 fill-current" aria-hidden="true">
        <circle cx="1" cy="1" r="1" />
    </svg>
</template>
